export * from './dynamic-html.component';
export * from './module';
export * from './interfaces';
export * from './options';
export * from './renderer';



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/~/ng-dynamic/src/dynamic-html/index.js
// module id = ../../../../ng-dynamic/src/dynamic-html/index.js
// module chunks = 3